import graphqlClient from "../../api/axios_interceptor";
import {
    SendInvoiceSmsMutation,
    SendPaymentReceiptSmsMutation,
    SendSmsMutation,
    SendPaymentReminderSmsMutation,
    SendBulkPaymentReminderSmsMutation,
    SendTenantStatementSmsMutation,
    ResendSmsMutation
} from "../../api/graphql/queries/sms";
import {
    SEND_BULK_PAYMENT_REMINDER, SEND_INVOICE,
    SEND_PAYMENT_RECEIPT, SEND_PAYMENT_REMINDER,
    SEND_MESSAGE, SEND_TENANT_STATEMENT, RESEND_MESSAGE
} from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";



const tenantStatementMiddleware = async (action) => {
    try{
        await graphqlClient({
            data: {
                query: SendTenantStatementSmsMutation(action.payload.tenantIds)
            }
        }).then(queryResult => {
            if(queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.sendTenantStatementSms.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        message: queryResult.data.data.sendTenantStatementSms.message,
                    }
                }
            }
        })
    } catch(error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const smsMiddleware = storeAPI => next => async action => {
    let smsInfo = action.payload;

    switch (action.type) {
        case SEND_TENANT_STATEMENT:
            action = await tenantStatementMiddleware(action);
            break;
        case SEND_MESSAGE:
            try {
                await graphqlClient({
                    data: {
                        query: SendSmsMutation(smsInfo.propertyIds, smsInfo.tenantIds, smsInfo.customMessage)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (queryResult.data.data.sendSms.success === 'false') {
                        let error = queryResult.data.data.sendSms.message || 'Sorry, could not send the message';
                        action = updateActionErrors(action, error);
                    } else {
                        let message = queryResult.data.data.sendSms.message;
                        action = {
                            ...action,
                            payload: {
                                ...action.payload,
                                message
                            }
                        };
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case RESEND_MESSAGE:
            try {
                await graphqlClient({
                    data: {
                        query: ResendSmsMutation(smsInfo)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (!queryResult.data.data.resendSms.success) {
                        let error = queryResult.data.data.resendSms.message;
                        action = updateActionErrors(action, error);
                    } else{
                        let message = queryResult.data.data.resendSms.message;
                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                message
                            },
                        })
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case SEND_INVOICE:
            try {
                await graphqlClient({
                    data: {
                        query: SendInvoiceSmsMutation(smsInfo.invoiceIds, smsInfo.sendDate || "")
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (queryResult.data.data.sendInvoiceSms.success === 'false') {
                        let error = queryResult.data.data.sendInvoiceSms.message ||  'Sorry, could not send the message(s)';
                        action = updateActionErrors(action, error);
                    } else {
                        let invoices = queryResult.data.data.sendInvoiceSms.invoices ? queryResult.data.data.sendInvoiceSms.invoices : ""
                        let message = queryResult.data.data.sendInvoiceSms.message || 'Invoice reminder(s) sent sucessfully'
                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                invoices,
                                message
                            },
                        });
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case SEND_PAYMENT_RECEIPT:
            try {
                await graphqlClient({
                    data: {
                        query: SendPaymentReceiptSmsMutation(smsInfo.paymentIds)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (!queryResult.data.data.sendPaymentReceipts.success) {
                        let error = queryResult.data.data.sendPaymentReceipts.message || 'Sorry, could not send the message(s)';
                        action = updateActionErrors(action, error);
                    } else {
                        let payments = [];
                        if(queryResult.data.data.sendPaymentReceipts.payments){
                            payments = queryResult.data.data.sendPaymentReceipts.payments.map(payment => ({
                                paymentId: payment.id,
                                message: payment.message ? payment.message.id : ""
                            }))
                        }
                        let message = queryResult.data.data.sendPaymentReceipts.message
                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                payments,
                                message
                            }
                        });
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        case SEND_PAYMENT_REMINDER:
            try {
                await graphqlClient({
                    data: {
                        query: SendPaymentReminderSmsMutation(smsInfo.tenantIds)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (!queryResult.data.data.sendPaymentReminder.success) {
                        let error = queryResult.data.data.sendPaymentReminder.message || 'Sorry, could not send the message(s)';
                        action = updateActionErrors(action, error);
                    }else{
                        let message = queryResult.data.data.sendPaymentReminder.message
                        action = (
                            {
                                ...action,
                                payload: {
                                    ...action.payload,
                                    message
                                }
                            }
                        )
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case SEND_BULK_PAYMENT_REMINDER:
            try {
                await graphqlClient({
                    data: {
                        query: SendBulkPaymentReminderSmsMutation(smsInfo.propertyIds)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (!queryResult.data.data.sendBulkPaymentReminders.success) {
                        let error = queryResult.data.data.sendBulkPaymentReminders.message || 'Sorry, could not send the messages';
                        action = updateActionErrors(action, error);
                    } else {
                        let message = queryResult.data.data.sendBulkPaymentReminders.message || 'Balance reminders sent successfully'
                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                message
                            }
                        });
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

    }
    return next(action);
};


export {
    smsMiddleware
}